import axios from 'axios';
import config from '@/config/env-constants';

export default {

    getDisposalRequest(param) {
        let url = `${config.cloudFunctionsBaseUrl}/getDisposalRequest`;
        return axios.post(url, {
            currUserId: param.currUserId,
            filterBy: JSON.stringify(param.filterBy),
            view: param.view
        });
    },
    paginateDisposalRequests(param) {
        let url = `${config.cloudFunctionsBaseUrl}/paginateDisposalRequests`;
        return axios.post(url, {
            currUserId: param.currUserId,
            filterBy: JSON.stringify(param.filterBy),
            view: param.view,
            page: param.page,
            limit: param.limit,
            startAt: param.startAt,
            direction: param.direction
        });
    },
    saveDisposalRequest(param) {
        let url = `${config.cloudFunctionsBaseUrl}/saveDisposalRequest`;
        return axios.post(url, {
            currUserId: param.currUserId,
            disposalRequest: JSON.stringify(param.disposal),
        });
    },
    approveMultipleDisposalRequests(param) {
        let url = `${config.cloudFunctionsBaseUrl}/approveMultipleDisposalRequests`;
        return axios.post(url, {
            currUserId: param.currUserId,
            disposalRequestArr: JSON.stringify(param.disposalArr),
        });
    },
    doneMultipleDisposalRequests(param) {
        let url = `${config.cloudFunctionsBaseUrl}/doneMultipleDisposalRequests`;
        return axios.post(url, {
            currUserId: param.currUserId,
            disposalRequestArr: JSON.stringify(param.disposalArr),
        });
    }
}